export const NAME = "core/i18n";

export const DefaultVariables = {
    PORTAL_NAME: "PORTAL_NAME",
    CC_PHONE: "CC_PHONE",
    CC_EMAIL: "CC_EMAIL",
};
